import { Link } from 'react-router-dom'
import { Menu, ChevronRight, Bike, Wrench, BatteryCharging, Shield, Zap, Package, Tag, Settings } from 'lucide-react'
import { useCategories } from '@/modules/categories-api'

const ICONS: Record<string, React.ComponentType<{ className?: string }>> = {
  'bike': Bike,
  'wrench': Wrench,
  'battery-charging': BatteryCharging,
  'shield': Shield,
  'zap': Zap,
  'package': Package,
  'tag': Tag,
  'settings': Settings,
}

export function CategorySidebar() {
  const { data: categories } = useCategories()
  const sorted = (categories ?? []).slice().sort((a, b) => a.order - b.order)

  return (
    <aside className="w-[280px] shrink-0">
      <div className="h-14 px-5 rounded-t-lg bg-brand-600 text-white flex items-center gap-3 font-semibold">
        <Menu className="w-5 h-5" />
        <span className="flex-1">Danh mục sản phẩm</span>
        <ChevronRight className="w-4 h-4" />
      </div>
      <ul className="bg-surface border border-t-0 border-border rounded-b-lg overflow-hidden shadow-card">
        {sorted.map((cat) => {
          const Icon = ICONS[cat.icon] ?? Bike
          return (
            <li key={cat.id}>
              <Link
                to={`/danh-muc/${cat.slug}`}
                className="flex items-center gap-3 px-5 h-12 text-[14px] text-text hover:bg-brand-50 hover:text-brand-600 transition border-b border-border last:border-b-0"
              >
                <Icon className="w-5 h-5 text-brand-600" />
                <span className="flex-1">{cat.label}</span>
                <ChevronRight className="w-4 h-4 text-muted" />
              </Link>
            </li>
          )
        })}
      </ul>
    </aside>
  )
}
